import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Phone } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { money } from "@/lib/booking";

const STATUS = { pending: ["Pendiente", "bg-[#C4823F]/15 text-[#7a4a1c]"], confirmed: ["Confirmada", "bg-[#264639]/15 text-[#264639]"], cancelled: ["Cancelada", "bg-[#2C2016]/10 text-[#2C2016]/60"] };

export const Card = ({ children, className = "" }) => <div className={`rounded-2xl border border-[#2C2016]/10 bg-white p-5 sm:p-6 ${className}`}>{children}</div>;

export const BookingsTab = ({ prop }) => {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("all");
  const load = useCallback(() => api.get(`/admin/bookings?property_id=${prop.id}`).then((r) => setList(Array.isArray(r.data) ? r.data : [])), [prop.id]);
  useEffect(() => { load(); }, [load]);
  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/bookings/${id}`, { status });
      toast.success("Reserva actualizada");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const shown = filter === "all" ? list : list.filter((b) => b.status === filter);
  return (
    <div className="mt-6 space-y-4" data-testid="admin-bookings">
      <div className="flex flex-wrap gap-2">
        {[["all", "Todas"], ["pending", "Pendientes"], ["confirmed", "Confirmadas"], ["cancelled", "Canceladas"]].map(([v, l]) => (
          <button key={v} data-testid={`bookings-filter-${v}`} onClick={() => setFilter(v)} className={`rounded-full px-4 py-1.5 text-sm ${filter === v ? "bg-[#2C2016] text-[#FBF8F2]" : "bg-white"}`}>{l} ({v === "all" ? list.length : list.filter((b) => b.status === v).length})</button>
        ))}
      </div>
      {shown.length === 0 && <Card><p className="text-sm text-[#4A3525]">No hay solicitudes todavía.</p></Card>}
      {shown.map((b) => (
        <Card key={b.id} className="grid gap-4 md:grid-cols-12 md:items-center">
          <div className="md:col-span-4">
            <p className="font-mono text-xs tracking-widest text-[#8A5A2B]">{b.code}</p>
            <p data-testid={`booking-row-name-${b.code}`} className="text-lg font-semibold">{b.name}</p>
            <p className="flex items-center gap-1 text-sm text-[#4A3525]"><Mail className="h-3.5 w-3.5" /><a href={`mailto:${b.email}`} className="underline">{b.email}</a></p>
            {b.phone && <p className="flex items-center gap-1 text-sm text-[#4A3525]"><Phone className="h-3.5 w-3.5" />{b.phone}</p>}
          </div>
          <div className="text-sm md:col-span-4">
            <p className="font-medium">{b.check_in} → {b.check_out} · {b.nights} noches</p>
            <p className="text-[#4A3525]">{b.adults} adultos{b.children ? `, ${b.children} niños` : ""} · idioma {b.lang?.toUpperCase()}</p>
            {b.message && <p className="mt-1 italic text-[#4A3525]">“{b.message}”</p>}
          </div>
          <div className="flex flex-wrap items-center gap-2 md:col-span-4 md:justify-end">
            <span className="mr-2 font-semibold">{money(b.total)}</span>
            <span className={`rounded-full px-3 py-1 text-xs font-semibold ${STATUS[b.status]?.[1]}`}>{STATUS[b.status]?.[0]}</span>
            {b.status !== "confirmed" && <button data-testid={`booking-confirm-${b.code}`} onClick={() => setStatus(b.id, "confirmed")} className="rounded-lg bg-[#264639] px-3 py-1.5 text-xs font-semibold text-white">Confirmar</button>}
            {b.status !== "cancelled" && <button data-testid={`booking-cancel-${b.code}`} onClick={() => setStatus(b.id, "cancelled")} className="rounded-lg border border-[#2C2016]/20 px-3 py-1.5 text-xs font-semibold">Cancelar</button>}
          </div>
        </Card>
      ))}
    </div>
  );
};
